import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
const ConnectedStackBarSkeleton = ({ sx, width, height }) => {
    return (
        <Box sx={{ minWidth:{width}, height: {width}, ...sx }}>
            <Skeleton sx={{ width: width, height: height }} variant="rectangular" animation="wave" />
        </Box>
    );
};

export default ConnectedStackBarSkeleton;
